// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Help-hosted site forms (#site-form-root) — brand tokens without the main SPA shell.
   Keep docs chrome white (#fff / --bg), not the SPA shell gray from appThemeBridge. */
html:has(#site-form-root),
body:has(#site-form-root),
html:has(.nm-react-widget-root[data-nm-site-form]),
body:has(.nm-react-widget-root[data-nm-site-form]) {
  background: #ffffff !important;
}

#site-form-root,
.nm-react-widget-root[data-nm-site-form] {
  --nm-brand: #2781f6;
  --nm-on-primary-text: #fff;
  --primary-color: #2781f6;
  --primary-hover: #2781f6;
  --primary-light-tint: #dbeafe;
  --primary-lighter-tint: #f0f7ff;
  --text-primary: #1c2024;
  --text-secondary: #60646c;
  --border-color: #eaeaea;
  --nm-neutral-border: #eaeaea;
  --nm-neutral-primary-text: #1c2024;
  --nm-neutral-secondary-text: #60646c;
  --nm-danger-bg-soft: #fde8e8;
  --nm-red-ink: #c81e1e;
  --nm-secondary-surface: 254 254 254;
  --slate-6: 217 217 224;
  --slate-12: 28 32 36;
  --alpha-2: 196 197 198;
  --nm-input-fill: #f7f7f7;
  --border-weak: 234 234 234;
  --black-alpha-2: 0, 0, 0, 0.04;
  --nm-radius: 0.5rem;
  --font-size-sm: 14px;
  --spacing-sm: 8px;
  color: #1c2024;
  color-scheme: light;
}

#site-form-root .nm-portal-form-widget .react-btn-primary.nm-portal-form-submit {
  background: #2781f6 !important;
  color: #fff !important;
  cursor: pointer;
}

#site-form-root .nm-portal-form-widget .react-btn-primary.nm-portal-form-submit:hover:not(:disabled) {
  filter: brightness(1.1);
  background: #2781f6 !important;
  cursor: pointer;
}

#site-form-root .nm-portal-form-widget .react-btn-primary.nm-portal-form-submit:disabled {
  opacity: 0.5 !important;
  cursor: not-allowed;
  filter: none;
}

#site-form-root .nm-portal-form-widget .react-btn-primary.nm-portal-form-submit.has-errors:disabled {
  opacity: 1 !important;
  background: #fde8e8 !important;
  color: #c81e1e !important;
  cursor: not-allowed;
}

#site-form-root .nm-portal-form-widget .react-btn-primary.nm-portal-form-submit.loading:not(:disabled) {
  cursor: progress;
}
`, "",{"version":3,"sources":["webpack://./src/siteForm/siteFormHost.css"],"names":[],"mappings":"AAAA;sFACsF;AACtF;;;;EAIE,8BAA8B;AAChC;;AAEA;;EAEE,mBAAmB;EACnB,0BAA0B;EAC1B,wBAAwB;EACxB,wBAAwB;EACxB,6BAA6B;EAC7B,+BAA+B;EAC/B,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,4BAA4B;EAC5B,kCAAkC;EAClC,oCAAoC;EACpC,4BAA4B;EAC5B,qBAAqB;EACrB,mCAAmC;EACnC,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,wBAAwB;EACxB,0BAA0B;EAC1B,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* Help-hosted site forms (#site-form-root) — brand tokens without the main SPA shell.\n   Keep docs chrome white (#fff / --bg), not the SPA shell gray from appThemeBridge. */\nhtml:has(#site-form-root),\nbody:has(#site-form-root),\nhtml:has(.nm-react-widget-root[data-nm-site-form]),\nbody:has(.nm-react-widget-root[data-nm-site-form]) {\n  background: #ffffff !important;\n}\n\n#site-form-root,\n.nm-react-widget-root[data-nm-site-form] {\n  --nm-brand: #2781f6;\n  --nm-on-primary-text: #fff;\n  --primary-color: #2781f6;\n  --primary-hover: #2781f6;\n  --primary-light-tint: #dbeafe;\n  --primary-lighter-tint: #f0f7ff;\n  --text-primary: #1c2024;\n  --text-secondary: #60646c;\n  --border-color: #eaeaea;\n  --nm-neutral-border: #eaeaea;\n  --nm-neutral-primary-text: #1c2024;\n  --nm-neutral-secondary-text: #60646c;\n  --nm-danger-bg-soft: #fde8e8;\n  --nm-red-ink: #c81e1e;\n  --nm-secondary-surface: 254 254 254;\n  --slate-6: 217 217 224;\n  --slate-12: 28 32 36;\n  --alpha-2: 196 197 198;\n  --nm-input-fill: #f7f7f7;\n  --border-weak: 234 234 234;\n  --black-alpha-2: 0, 0, 0, 0.04;\n  --nm-radius: 0.5rem;\n  --font-size-sm: 14px;\n  --spacing-sm: 8px;\n  color: #1c2024;\n  color-scheme: light;\n}\n\n#site-form-root .nm-portal-form-widget .react-btn-primary.nm-portal-form-submit {\n  background: #2781f6 !important;\n  color: #fff !important;\n  cursor: pointer;\n}\n\n#site-form-root .nm-portal-form-widget .react-btn-primary.nm-portal-form-submit:hover:not(:disabled) {\n  filter: brightness(1.1);\n  background: #2781f6 !important;\n  cursor: pointer;\n}\n\n#site-form-root .nm-portal-form-widget .react-btn-primary.nm-portal-form-submit:disabled {\n  opacity: 0.5 !important;\n  cursor: not-allowed;\n  filter: none;\n}\n\n#site-form-root .nm-portal-form-widget .react-btn-primary.nm-portal-form-submit.has-errors:disabled {\n  opacity: 1 !important;\n  background: #fde8e8 !important;\n  color: #c81e1e !important;\n  cursor: not-allowed;\n}\n\n#site-form-root .nm-portal-form-widget .react-btn-primary.nm-portal-form-submit.loading:not(:disabled) {\n  cursor: progress;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
